/**
 * @fileoverview GET handler for the "/engagement/prediction_stats(/:prediction_id)" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementPredictionStatsPredictionId } from "./constants";
import type { EngagementPredictionStatsPredictionIdResult } from "./types";

export const getEngagementPredictionStatsPredictionId = reactQueryFetcherAdapter(
  engagementPredictionStatsPredictionId,
  (signal: AbortSignal, predictionId: string): Promise<EngagementPredictionStatsPredictionIdResult> => {
    return fetch(`/engagement/prediction_stats/${predictionId}`, "GET", {}, { signal });
  }
);
